module.exports = __webpack_public_path__ + "static/media/villas-icon-blue.7ea296d8.PNG";